<template>
  <div class="sidebar" id="sidebar">
    <div class="close" id="closeSidebar" @click="hideInMobile">
      <i class="fa-solid fa-xmark"></i>
    </div>
    <div class="content">
      <div class="flex-big-gap spe-lo-pad mb-5">
        <div class="logo">
          <img :src="logo" alt="img" />
        </div>
        <div class="left-logo">
          <h6 class="font-bold">{{ $t('sidebar.appTitle') }}</h6>
          <p class="gray-col font14 mb-0">{{ $t('sidebar.dashboardSubtitle') }}</p>
        </div>
      </div>
      <ul class="links">
        <li>
          <router-link to="/dashboardHome">
            <span class="icon-co">
              <img :src="imgsideBar" alt="" />
            </span>
            {{ $t('sidebar.home') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/managementOrders">
            <span class="icon-co">
              <img src="@/assets/imgs/noun_list.png" alt="" />
            </span>
            {{ $t('sidebar.managementOrders') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/buildingsView">
            <span class="icon-co">
              <img src="@/assets/imgs/homeB.png" alt="" />
            </span>
            {{ $t('sidebar.properties') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/ownersView">
            <span class="icon-co">
              <img src="@/assets/imgs/users.png" alt="" />
            </span>
            {{ $t('sidebar.owners') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>
        <li @click="toggleSlide">
          <router-link
            to="/MaintenanceView"
            :class="{ active: route.name == 'TechniciansView' }"
          >
            <span class="icon-co">
              <img src="@/assets/imgs/setting.png" alt="" />
            </span>
            {{ $t('sidebar.maintenance') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
          <div
            class="dropSidebar"
            v-if="
              route.name == 'MaintenanceView' || route.name == 'TechniciansView'
            "
          >
            <router-link
              to="/MaintenanceView"
              class="flex-bet-main slide-link mb-1"
            >
              <div class="flex-sm-gap">
                <img src="@/assets/imgs/noun_list.png" class="verySMiMG" alt="" />
                <div>{{ $t('sidebar.maintenanceRequests') }}</div>
              </div>
              <i class="fa-solid fa-chevron-left"></i>
            </router-link>
            <router-link
              to="/TechniciansView"
              class="flex-bet-main slide-link mb-1"
            >
              <div class="flex-sm-gap">
                <img src="@/assets/imgs/users.png" class="verySMiMG" alt="" />
                <div>{{ $t('sidebar.technicians') }}</div>
              </div>
              <i class="fa-solid fa-chevron-left"></i>
            </router-link>
          </div>
        </li>
        <li>
          <router-link to="/manageGeneral">
            <span class="icon-co">
              <img src="@/assets/imgs/manage.png" alt="" />
            </span>
            {{ $t('sidebar.publicRelationsManagement') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/packagesDashboard">
            <span class="icon-co">
              <img src="@/assets/imgs/noun_list.png" alt="" />
            </span>
            {{ $t('sidebar.packages') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/walletView">
            <span class="icon-co">
              <img src="@/assets/imgs/wallet.png" alt="" />
            </span>
            {{ $t('sidebar.wallet') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/fainancialView">
            <span class="icon-co">
              <img src="@/assets/imgs/wallet.png" alt="" />
            </span>
            {{ $t('sidebar.financialAccounts') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/moreAboutSaqf">
            <span class="icon-co">
              <img src="@/assets/imgs/more.png" alt="" />
            </span>
            {{ $t('sidebar.moreAboutSaqf') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/contactDashboard">
            <span class="icon-co">
              <img src="@/assets/imgs/contact.png" alt="" />
            </span>
            {{ $t('sidebar.contactAdmin') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>

        <li class="relative-parent">
          <div class="abs-log-out" @click="logOut" :class="{noPointer : disabled}"></div>
          <router-link to="/loginView" class="log-out-red noPointer">
            <span class="icon-co" >
              <img :src="imgLogout" v-if="!disabled" alt="" />
              <div class="spinner-small-white" v-if="disabled"></div>
            </span>
            {{ $t('sidebar.logout') }}
            <i class="fa-solid fa-angle-left icon-right"></i>
          </router-link>
        </li>
        <!-- <div class="foot-spe mb-2 mt-4 px-3 font14">
          <div class="top-t mb-1">
            تصميم بواسطة <a href="#" target="_blank">اوامر الشبكة</a>
          </div>
        </div> -->
      </ul>
    </div>
  </div>
</template>

<script setup>
// imports
//   import pageHeader from "../components/pageHeader.vue";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();

const logo = ref(require("../../assets/imgs/logo.png"));
const imgsideBar = ref(require("../../assets/imgs/noun_dashboard_3595546.png"));
const imgLogout = ref(require("../../assets/imgs/noun_logout.png"));
const showSlide = ref(false);
const disabled = ref(false);

const route = useRoute();

// functions
function toggleSlide() {
  showSlide.value = !showSlide.value;
}
function hideInMobile() {
  document.querySelector(".main-sec").classList.remove("active-main");
  document.querySelector(".navbar-me").classList.remove("active-nav");
  document.querySelector(".sidebar").classList.remove("active-side");
}

function logOut() {
  disabled.value = true;
  // const fd = new FormData();

  axios
    .delete("/sign-out", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        localStorage.removeItem("phone");
        localStorage.removeItem("country_code");
        localStorage.removeItem("token");
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
        router.push("/loginView");
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}

// lifecycle hooks
onMounted(() => {
  // console.log(`mounted`);
  //   showPackages.value = true;
});
</script>
